import { SellerCenterSSOApiClient } from '@/apis';

export default {
  async singleSignOn ({ env, url, domain }) {
    return SellerCenterSSOApiClient.post('lms', {
      env,
      url,
      domain,
    }, { hideSpinner: true, hideErrorMessage: true });
  },
};
